export default function initForms() {

  if (!$('.form-input').length) return;

  $('.form-input')

    .on('focus', function () {

      $(this)
        .parents('.form-group')
        .addClass('focused');

    })

    .on('blur', function () {

      const $input = $(this);

      const hasValue = $input.val() !== '';

      $input.toggleClass('filled', hasValue);

      $input
        .parents('.form-group')
        .toggleClass('focused', hasValue);

    });

}
